import { render, staticRenderFns } from "./Assigned.vue?vue&type=template&id=436896bc&scoped=true&"
import script from "./Assigned.vue?vue&type=script&lang=js&"
export * from "./Assigned.vue?vue&type=script&lang=js&"
import style0 from "./Assigned.vue?vue&type=style&index=0&id=436896bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436896bc",
  null
  
)

export default component.exports